// @ts-nocheck
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Router, Location, RouteComponentProps, Redirect } from '@reach/router';

import { CssBaseline } from '@material-ui/core';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { SnackbarProvider } from 'notistack';

import { store, persistor } from 'store/configureStore';
import { SnackbarConfig } from 'commons/constants/KeyFlowConfig';

import NotoSansWoff2 from 'asset/font/noto-sans-kr-v13-korean-regular.woff2';
import NotoSansWoff from 'asset/font/noto-sans-kr-v13-korean-regular.woff';

import { Login, ContentsLayout, Preview, AppLayout, Error } from 'pages';

import {
  SearchFilterByDate,
  SearchFilterByRecord,
  SearchFilterBySpecial,
} from 'components/SearchFilter';

export const theme = createMuiTheme({
  typography: {
    fontFamily: 'Noto Sans KR',
    fontSize: 12,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [
          {
            fontFamily: 'Noto Sans KR',
            fontStyle: 'normal',
            fontDisplay: 'swap',
            fontWeight: 400,
            src: `
            local(''),
            local('Noto Sans KR'),
            url(${NotoSansWoff2}) format('woff2'),
            url(${NotoSansWoff}) format('woff')
          `,
          },
        ],
        html: {
          WebkitFontSmoothing: 'auto',
          letterSpacing: -1,
        },
        body: {
          backgroundColor: 'inherit',
        },
        // arial 폰트로 스타일이 덮어 씌워지는 문제로 추가
        button: {
          fontFamily: 'Noto Sans KR',
        },
        input: {
          fontFamily: 'Noto Sans KR',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1920,
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div>로딩중...</div>}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider {...SnackbarConfig}>
            <CssBaseline />
            <Location>
              {({ location }) => {
                return (
                  <Router location={location}>
                    <RouterPage path="/login" pageComponent={<Login />} />
                    <AppLayout path="/">
                      <ContentsLayout path="search">
                        <RouterPage path="/date" pageComponent={<SearchFilterByDate />} default />
                        <RouterPage path="/record" pageComponent={<SearchFilterByRecord />} />
                        <RouterPage path="/special" pageComponent={<SearchFilterBySpecial />} />
                      </ContentsLayout>
                      <RouterPage path="preview/:assetId" pageComponent={<Preview />} />
                      <RouterPage path="errorPage/:errorCode" pageComponent={<Error />} />
                    </AppLayout>
                  </Router>
                );
              }}
            </Location>
          </SnackbarProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export const RouterPage = (props: { pageComponent: JSX.Element } & RouteComponentProps) =>
  props.pageComponent;

export default App;
